import { FC } from "react";
import { ColumnProps } from "templates/relaunch/MultiColumn/components/Column/Column.types";

import { CityCardProps } from "components/Relaunch/Locations/FeaturedCities/components";
import { CtaButtonProps } from "components/CtaButton";
import { ClinicPageEntity } from "types/clinic";
import { SEOHeadingExtension } from "types/seo";

import { ColumnBeforeAndAfterProps } from "./components";

export interface MultiColumnSliderContent {
    title: string;
    items:
        | ColumnBeforeAndAfterProps[]
        | ClinicPageEntity[]
        | ColumnProps[]
        | CityCardProps[];

    withExpansion?: boolean;
    mobileSwiper?: boolean;
    subtitle?: string;
    cta?: CtaButtonProps;
    disclaimer?: string;
    itemContent?: Record<string, string>;
    direction?: DirectionType;
    gridSpacing?: string;
}

export interface MultiColumnSliderProps extends SEOHeadingExtension {
    content: MultiColumnSliderContent;

    itemComponent?: FC<any>;
}

export enum DirectionType {
    Vertical = "vertical",
    Horizontal = "horizontal",
}
